var HasPage = function (key) {
    return this.sizerChildren.hasOwnProperty(key);
}

export default HasPage;